import { ReactNode } from 'react';

import { ContainerWithOptions, ContainerWithOptionsProps } from '../../../common/Common/OptionsDropdown';
import UI from '../../../common/UI';
import useMediaDevice from '../../../common/useMediaDevice';

interface CardPreviewProps {
  title: string;
  subTitle?: ReactNode;
  firstColumn?: ReactNode;
  secondColumn?: ReactNode;
  options?: ContainerWithOptionsProps['renderOptions'];
  active?: boolean;
  status: ReactNode;
  onToggle: () => unknown;
}

const CardPreview = ({
  title,
  subTitle,
  firstColumn,
  secondColumn,
  options,
  active,
  status,
  onToggle,
}: CardPreviewProps) => {
  const device = useMediaDevice();

  return (
    <ContainerWithOptions
      name={title}
      renderOptions={options}
    >
      <UI.GridContainer sc={{ columns: ['3fr 2fr', '6fr 4fr 6fr 200px'], gutter: 0.5, alignVertical: 'center' }}>
        <UI.Div
          style={{
            gridColumn: !device.isSmall ? `1 / span ${3 - (firstColumn ? 1 : 0) - (secondColumn ? 1 : 0)}` : undefined,
            minWidth: 0,
          }}
        >
          <UI.FlexContainer sc={{ spaceX: 2, alignItems: 'center' }}>
            <UI.H4 style={{ minWidth: 0 }}>
              <UI.Truncate>
                {title}
              </UI.Truncate>
            </UI.H4>
            {subTitle}
          </UI.FlexContainer>
          {device.isSmall && firstColumn && (
            <UI.Div sc={{ color: 'gray.500' }}>
              {firstColumn}
            </UI.Div>
          )}
        </UI.Div>

        {!device.isSmall && firstColumn && (
          <UI.Div sc={{ color: 'gray.500' }}>
            {firstColumn}
          </UI.Div>
        )}

        {!device.isSmall && secondColumn && (
          <UI.Div sc={{ color: 'gray.500', small: true }}>
            {secondColumn}
          </UI.Div>
        )}

        <UI.FlexContainer sc={{ justifyContent: 'end', alignItems: 'center' }}>
          <UI.FlexContainer
            sc={{
              spaceX: [0, 2],
              textAlign: 'right',
              direction: ['column-reverse', 'row'],
              alignItems: ['end', 'center'],
            }}
          >
            <UI.Small sc={{ color: 'gray.500' }}>
              {status}
            </UI.Small>
            <UI.Span style={{ margin: '-2.5px 0' }}>
              <UI.Toggle checked={active} onChange={() => onToggle()} />
            </UI.Span>
          </UI.FlexContainer>
        </UI.FlexContainer>
      </UI.GridContainer>
    </ContainerWithOptions>
  );
};

export default CardPreview;
